var map = {
	"./AnimatePath": 27,
	"./AnimatePath/": 27,
	"./AnimatePath/index": 27,
	"./AnimatePath/index.jsx": 27,
	"./AnimatePath/svg/arrow": 88,
	"./AnimatePath/svg/arrow.svg": 88,
	"./AnimatePath/svg/vostel-logo": 89,
	"./AnimatePath/svg/vostel-logo.svg": 89,
	"./BackToTop": 51,
	"./BackToTop/": 51,
	"./BackToTop/index": 51,
	"./BackToTop/index.jsx": 51,
	"./BackToTop/style.module": 57,
	"./BackToTop/style.module.scss": 57,
	"./Donation": 31,
	"./Donation/": 31,
	"./Donation/index": 31,
	"./Donation/index.jsx": 31,
	"./Donation/style.module": 13,
	"./Donation/style.module.scss": 13,
	"./DonationList": 52,
	"./DonationList/": 52,
	"./DonationList/index": 52,
	"./DonationList/index.jsx": 52,
	"./DonationList/style.module": 37,
	"./DonationList/style.module.scss": 37,
	"./ImageHeader": 56,
	"./ImageHeader/": 56,
	"./ImageHeader/index": 56,
	"./ImageHeader/index.jsx": 56,
	"./ImageHeader/style.module": 9,
	"./ImageHeader/style.module.scss": 9,
	"./Menu": 53,
	"./Menu/": 53,
	"./Menu/Item": 58,
	"./Menu/Item.jsx": 58,
	"./Menu/index": 53,
	"./Menu/index.jsx": 53,
	"./Menu/style.module": 10,
	"./Menu/style.module.scss": 10,
	"./MenuMobile": 54,
	"./MenuMobile/": 54,
	"./MenuMobile/Item": 59,
	"./MenuMobile/Item.jsx": 59,
	"./MenuMobile/closed": 90,
	"./MenuMobile/closed.svg": 90,
	"./MenuMobile/index": 54,
	"./MenuMobile/index.jsx": 54,
	"./MenuMobile/open": 91,
	"./MenuMobile/open.svg": 91,
	"./MenuMobile/style.module": 8,
	"./MenuMobile/style.module.scss": 8,
	"./ResponsiveImage": 25,
	"./ResponsiveImage/": 25,
	"./ResponsiveImage/index": 25,
	"./ResponsiveImage/index.jsx": 25,
	"./Switch": 55,
	"./Switch/": 55,
	"./Switch/index": 55,
	"./Switch/index.jsx": 55,
	"./Switch/off": 92,
	"./Switch/off.svg": 92,
	"./Switch/on": 93,
	"./Switch/on.svg": 93,
	"./Switch/style.module": 11,
	"./Switch/style.module.scss": 11,
	"./helpers": 19,
	"./helpers/": 19,
	"./helpers/index": 19,
	"./helpers/index.jsx": 19
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;